/* unplugin-vue-components disabled */import { render } from "./APLink.vue?vue&type=template&id=22d2fed8"
import script from "./APLink.vue?vue&type=script&lang=js"
export * from "./APLink.vue?vue&type=script&lang=js"

import "./APLink.vue?vue&type=style&index=0&id=22d2fed8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__